// javascript
// app/javascript/controllers/chat_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.inputTarget.addEventListener("keydown", (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
        e.preventDefault()
        this.element.requestSubmit()
      }
    })

    this.element.addEventListener("submit", () => {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add("opacity-60")
    })

    // Auto-resize on connect (e.g. when content is pre-filled)
    this.autoResize()
  }

  autoResize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = Math.min(el.scrollHeight, 200) + "px"
  }
}